import React from 'react'

function GoogleReviews() {
  return (
    <>
      <script src="https://static.elfsight.com/platform/platform.js" async></script>
      <div className="elfsight-app-6f12a4f1-8cad-4617-ba43-84c0e2db3b3f" data-elfsight-app-lazy></div>
    </>
  )
}

export default GoogleReviews
